import { useState, useEffect } from "react";

export default function useTimedMessage(duration = 5000, fadeTime = 1000) {
    const [message, setMessage] = useState(null);
    const [fadeOut, setFadeOut] = useState(false);


    useEffect(() => {
        if (!message) return;

        const fadeTimer = setTimeout(()=> {
            setFadeOut(true);
        }, duration - fadeTime)

        const removeTimer = setTimeout(() => {
            setMessage(null);
            setFadeOut(false);
        }, duration);

        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(removeTimer);
        };
    }, [message, duration, fadeTime])

    return {
        message,
        setMessage,
        fadeOut
    }
}